import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const BPC157Calculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.bpc157} />;
};

export default BPC157Calculator;
